export class OrganizationChartLevel {
  protected constructor(private name: string, private level: number, private nameTec:string) {}

  static named(name: string, level: number, nameTec: string) {
    return new this(name, level, nameTec);
  }

  isIdentidiedBy(level: number): boolean {
    return this.level === level;
  }

  maxLevelWith(aLevel: number): number {
    return Math.max(this.level, aLevel);
  }

  getName(): string {
    return this.name;
  }
  getLevel(): number {
    return this.level;
  }
  getNameTec():string{
    return this.nameTec;
  }
}
